import MembershipDashboardPage from "./pages/MembershipDashboardPage";
import MemberDetailsPage from "./pages/MemberDetailsPage";
import MembershipBandsPage from "./pages/MembershipBandPage";
import MembershipManagement from "./pages/MembershipManagement";

export const membershipRoutes = [
  {
    // Privilege, not role — same gate as the sidebar link that leads here.
    path: "/membership-bands",
    element: <MembershipBandsPage />,
    perms: ["billing.band.access"],
  },
  {
    path: "/membership-dashboard",
    element: <MembershipDashboardPage />,
    // Permission alone: this screen shows what every member owes, so it is
    // gated by its own permission rather than by holding the admin role.
    perms: ["membership.analysis.access"],
  },
  {
    // Roles rather than perms here, deliberately: RequirePermission demands
    // BOTH when the two are given, and `member.access` is not created by any
    // seeder in this repo — gating on it could lock out admins who were never
    // granted it. Naming the roles keeps existing admin access untouched.
    path: "/member-list",
    element: <MembershipManagement />,
    roles: ["admin", "president"],
  },
  {
    // The list links straight to this page, so it carries the same roles —
    // otherwise the president gets a list whose every row leads nowhere.
    path: "/member-list/:id",
    element: <MemberDetailsPage />,
    roles: ["admin", "president"],
  },
  {
    path: "/admin/members/:id/dues",
    element: <MemberDetailsPage />,
    roles: ["admin"],
  },
];
